module.exports = __webpack_public_path__ + "static/assets/0c5eb602b377babb41f563c06700923e.svg";